/**
 * Endpoints for the customer-facing credit card application API.
 *
 * Mirrors the backend `CreditCardApplicationResource` (bank-loan-rest-api),
 * base path `/bank/loans/credit-cards/v2`. Paths are relative to
 * `window.env.WEB_API_ROOT` (see `common/app/api/client`).
 */
export const CreditCardApiPaths = {
  /** GET active application for the logged in user (no uid). */
  ActiveApplication: 'bank/loans/credit-cards/v2',
  /** GET / POST (update) / DELETE a single application by uid. */
  Application: 'bank/loans/credit-cards/v2/:uid',
  /** POST to initialize a new credit card application. */
  Init: 'bank/loans/credit-cards/v2/init',
  /** POST to start the evaluation (scoring) process. */
  Evaluate: 'bank/loans/credit-cards/v2/:uid/evaluate',
  /** POST a qualifying credit-limit decrease straight to Salesforce. */
  DecreaseLimit: 'bank/loans/credit-cards/v2/:uid/decrease-limit',
  /** GET the current application status. */
  ApplicationStatus: 'bank/loans/credit-cards/v2/:uid/status',
  /** GET the status for a given integration type (append `/:integrationType`). */
  IntegrationStatus: 'bank/loans/credit-cards/v2/:uid/integration-status',
  /** GET the per-program credit-limit bounds (static lookup, no uid). */
  CustomerPrograms: 'bank/loans/credit-cards/v2/customer-programs',
  /**
   * GET whether the current user is an onboarded bank customer (no uid).
   *
   * Calls bank-rest-api `/bank/customers/check/has-onboarded` to gate
   * non-bank customers out before an application exists.
   */
  Onboarded: 'bank/customers/check/has-onboarded',
} as const;
